import HandymanIcon from '@mui/icons-material/Handyman';
import type { SvgIconProps } from '@mui/material';

/**
 * Tree assistant toolbar / panel icon — “AI builder” via Material {@link HandymanIcon} (tools).
 * To use the hammer-only glyph instead, switch the import to {@code @mui/icons-material/Build}.
 */
const TreeAssistantIcon = (props: SvgIconProps) => <HandymanIcon {...props} />;

export default TreeAssistantIcon;
